import { ArrowForwardRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { TranslatorEventSource } from './TranslatorEventSource';
import { ServerEventSource } from './ServerEventSource';

export const ServerToTranslator = () => {
  return (
    <Stack direction={'row'} alignItems="center" spacing={4}>
      <ServerEventSource />
      <ArrowForwardRounded
        sx={{ color: (theme) => theme.palette.action.active }}
      />
      <TranslatorEventSource />
    </Stack>
  );
};
